import React, { useState } from "react";
import api from "../../../Api/api";

function SendRequestModal({ onClose }) {
  const [name, setName] = useState('');
  const [amount, setAmount] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (!currentUser) {
      alert("You must be logged in to send requests.");
      return;
    }

    const requestData = {
      toName: name,
      toEmail: email,
      amount: parseFloat(amount),
      fromEmail: currentUser.email 
    };

    try {
      const response = await api.post('/expense/settle', requestData);
      if (response.status === 201 || response.status === 200) {
        alert('Request sent!');
        onClose(); // close modal
      }
    } catch (error) {
      console.error(error);
      alert('Error sending request.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label className="form-label">To (Name)</label>
        <input
          type="text"
          className="form-control"
          value={name}
          onChange={e => setName(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">To (Email)</label>
        <input
          type="email"
          className="form-control"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Amount</label>
        <input
          type="number"
          className="form-control"
          value={amount}
          onChange={e => setAmount(e.target.value)}
          required
        />
      </div>
      <button type="submit" className="btn btn-primary">Send Request</button>
    </form>
  );
}

export default SendRequestModal;